/* eslint-disable prettier/prettier */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import AudienceComponent from './AudienceComponent';
import SelectedAudienceComponent from './SelectedAudienceComponent';
import Navbar from './Navbar';
import i18n from '../../../app/i18n';

const Audiences = ({ user, winWidth, audiences, audienceRedirect }) =>
  audiences.map(audience =>
    <AudienceComponent 
      {...audience}
      missingThumbPath={user.missingThumbPath}
      winWidth={winWidth}
      audienceRedirect={audienceRedirect}
      key={audience.id}
      />
    )

const AudiencesComponent = props =>
  Object.keys(props.selectedAudience).length ? (
    <SelectedAudienceComponent
      selectedAudience={props.selectedAudience}
      tiles={props[`audienceTiles${props.selectedAudience.id}`]}
      navbarRedirect={props.navbarRedirect}
      copyAllTiles={props.copyAllTiles}
      copyTile={props.copyTile}
      user={props.user}
      tilePageLoaded={props.tilePageLoaded}
      scrollLoading={props.scrollLoading}
      openTileModal={props.openTileModal}
    />
  ) : (
    <>
      <Navbar navName={i18n.t('explore:allTopics')} showButtons={false} />
      <AudiencesWrapper><Audiences {...props} /></AudiencesWrapper>
    </>
  );

AudiencesComponent.propTypes = {
  audiences: PropTypes.array,
  audienceRedirect: PropTypes.func,
};

export default AudiencesComponent;

const AudiencesWrapper = styled.div`
  ${themeGet('mediaQueries.forMediumUp')} {
    display: grid;
    margin: 0 24px;
    grid-gap: 24px 18px;
    grid-template-columns: repeat(auto-fill, 282px);
  }
`;
